// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var ContentScriptPlayback__FocusElement$SmartcutsMacros = require("./ContentScriptPlayback__FocusElement.bs.js");

function dispatchMouseEvent(buttonOpt, buttonsOpt, clientX, clientY, htmlElement, eventName) {
  var button = buttonOpt !== undefined ? buttonOpt : 0;
  var buttons = buttonsOpt !== undefined ? buttonsOpt : 0;
  var mouseEvent = new MouseEvent(eventName, {
        button: button,
        buttons: buttons,
        bubbles: true,
        cancelable: true,
        clientX: clientX,
        clientY: clientY,
        composed: true
      });
  return htmlElement.dispatchEvent(mouseEvent);
}

function click(clientX, clientY, element) {
  $$Array.map((function (eta) {
          return dispatchMouseEvent(undefined, undefined, clientX, clientY, element, eta);
        }), [
        "mouseover",
        "mousedown"
      ]);
  ContentScriptPlayback__FocusElement$SmartcutsMacros.maybeDispatchFocusEvents(element);
  $$Array.map((function (eta) {
          return dispatchMouseEvent(undefined, undefined, clientX, clientY, element, eta);
        }), [
        "mouseup",
        "click"
      ]);
  return Promise.resolve(undefined);
}

function contextmenu(clientX, clientY, element) {
  dispatchMouseEvent(2, 2, clientX, clientY, element, "contextmenu");
  return Promise.resolve(undefined);
}

exports.dispatchMouseEvent = dispatchMouseEvent;
exports.click = click;
exports.contextmenu = contextmenu;
/* ContentScriptPlayback__FocusElement-SmartcutsMacros Not a pure module */
